export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $teaserclassic = document.querySelectorAll('.ce__isnack-teaserclassic-teaser');

        if (!$teaserclassic.length) {
            return;
        }

        $teaserclassic.forEach((teaser) => {
            /*
             * BUGFIX:
             * need eqh for all element, nessessary for images.
             * all images have the same ratio x/y, but if an image is rendered e.g with heigth "420" and another with "421" (math round in browser),
             * the eqh element below has not the same top-offset and is handled as a new row - so the element has its own height-px and is not equal to its other dom elements.
             */
            const itemselectorImageBox = '#' + teaser.id + ' .ce__isnack-teaserclassic-teaser-image';
            const itemselectorHeader = '#' + teaser.id + ' .ce__isnack-teaserclassic-teaser-header';
            const $equalHeightItemImageBox = teaser.querySelectorAll(itemselectorImageBox);
            const $equalHeightItemHeader = teaser.querySelectorAll(itemselectorHeader);

            if ($equalHeightItemImageBox.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorImageBox);
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    }, 500);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });
            }

            if ($equalHeightItemHeader.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorHeader);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorHeader);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorHeader);
                    });
                });
            }
        });
    });
}
